var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"masonry-container"},_vm._l((_vm.imgs),function(img,index){return _c('figure',{key:index,staticClass:"masonry-item",class:'masonry-item-'+(index + 1)},[_c('img',{attrs:{"src":img.foto,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }